import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "nav-button" }
const _hoisted_2 = { class: "nav-button" }
const _hoisted_3 = { class: "nav-button" }
const _hoisted_4 = { class: "nav-button" }
const _hoisted_5 = {
  key: 0,
  class: "badge"
}
const _hoisted_6 = {
  key: 0,
  class: "nav-button"
}
const _hoisted_7 = {
  key: 1,
  class: "nav-button2 mr-2"
}

import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import ProfilePhoto from '@/components/ProfilePhoto.vue';
import { duellyEventEmitter } from '@/services/eventBus';
import { useAuthStore } from '@/store/authStore';
import { useNostrMessageStore } from '@/store/nostrMessageStore';
import { useNoticeStore } from '@/store/noticeStore';

import { navigateTo, navigateToFeed } from './utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomNavBar',
  setup(__props, { expose: __expose }) {

const route = useRoute();
const authStore = useAuthStore();
const noticeStore = useNoticeStore();
const nostrMessageStore = useNostrMessageStore();

const userProfile = ref(authStore.getUserProfile());

const bottomNav = ref();
const showFeedPopup = ref(false);

__expose({ bottomNav }); // So parent can read height if needed

const unreadNotifications = computed(() => {
    const resp = noticeStore.unreadCount;
    return resp;
});

function goTo(path: string) {
    showFeedPopup.value = false;
    window.location.href = path;
}

const viewNavBar = () => {
    userProfile.value = authStore.getUserProfile();
    if (route.path === '/login' || route.path === '/' || route.path.startsWith('/admin')) {
        return false;
    } else {
        return true;
    }
};

onMounted(async () => {
    // Listen for login event
    await noticeStore.fetchNotifications(null, 1000);
});

return (_ctx: any,_cache: any) => {
  return (viewNavBar())
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "bottom-nav",
        ref_key: "bottomNav",
        ref: bottomNav
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            class: "pb-1",
            style: {"font-size":"28px !important"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goTo('/post-feed-view?type=challenge&reset')))
          }, " 🏆")
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "pb-1",
            style: {"font-size":"28px !important"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo('/search')))
          }, " 🔎")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            class: "pb-1",
            style: {"font-size":"28px !important"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ path: '/create-content', query: { type: 'challenge' } })))
          }, " ✨")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "icon-with-badge",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/notifications'))),
            title: "Notifications"
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { style: {"font-size":"28px !important"} }, "🔔", -1)),
            (unreadNotifications.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(unreadNotifications.value > 99 ? '99+' : unreadNotifications.value), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (userProfile.value.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(ProfilePhoto, {
                id: "step3",
                class: "mr-2",
                username: userProfile.value.username,
                profile_photo: userProfile.value.profile_photo,
                size: "small",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(navigateTo)(_ctx.$router, '/user-management')))
              }, null, 8, ["username", "profile_photo"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("a", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(duellyEventEmitter).emit('show-login-overlay')))
              }, "Login")
            ]))
      ], 512))
    : _createCommentVNode("", true)
}
}

})